// extracted by mini-css-extract-plugin
export default {"btn_choice":"AdditionalTask_btn_choice__bw0+L"};